import type { SignupAttribution } from '@alexiarest/shared';

const KEY = 'alexia:signup-attribution';
const TTL = 30 * 86400000;
/** First campaign in this browser, kept through the authentication redirect. */
export function storedAttribution(): SignupAttribution | undefined {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) ?? 'null');
    if (!saved || typeof saved.at !== 'number' || Date.now() - saved.at > TTL) return;
    return saved.value;
  } catch { return; }
}
export function rememberAttribution(search = window.location.search): void {
  try {
    if (storedAttribution()) return;
    const params = new URLSearchParams(search);
    const value: SignupAttribution = {};
    for (const key of ['source', 'medium', 'campaign', 'content'] as const) {
      const raw = params.get(`utm_${key}`)?.trim();
      // Only campaign labels, never the full URL, emails or query strings.
      if (raw && raw.length <= 120 && /^[\p{L}\p{N} _.,:/-]+$/u.test(raw)) value[key] = raw;
    }
    if (Object.keys(value).length) localStorage.setItem(KEY, JSON.stringify({ at: Date.now(), value }));
  } catch { /* Registration also works when storage is disabled. */ }
}
export function clearAttribution(): void {
  try { localStorage.removeItem(KEY); } catch { /* optional storage */ }
}
